module.exports = __webpack_public_path__ + "img/unload-4-1.4a1acd4f.png";